import * as React from 'react';
import { Button } from '@salesforce/design-system-react';
import { TimelineLite, Power3 } from 'gsap';
import { GuideText,  ScreenName } from 'lib/types';
import './guide.css';
import withBrand, { InjectedBrandProps } from 'lib/withBrand';

interface GuideProps extends InjectedBrandProps {
	nav: ScreenName;
	onClick: (nav: ScreenName) => void;
}
class Guide extends React.Component<GuideProps> {
	handleClose = () => {
		const ease = Power3.easeOut;
		const timeline = new TimelineLite();
		const DEBUG_DELAY = 1;
		const delay = 0.5 * DEBUG_DELAY;
		const guide = document.querySelector('.guide') as {};
		const body = document.querySelector('.body > div') as {};
		timeline
			.to(guide, delay, {height: 0, ease})
			.to(body, delay, {top: '62px', ease}, `-=${delay / 1.1}`);
	}

	handleMapperClose = () => { // FIXME: Don't duplicate this
		const ease = Power3.easeOut;
		const timeline = new TimelineLite();
		const DEBUG_DELAY = 1;
		const delay = 0.5 * DEBUG_DELAY;
		const guide = document.querySelector('.guide') as {};
		const body = document.querySelector('.body > div > div') as {};
		timeline
			.to(guide, delay, {height: 0, ease})
			.to(body, delay, {top: '51px', ease}, `-=${delay / 1.1}`);
	}

	renderAstroGuide (guide: GuideText) {
		const showButton = Boolean(guide.button);
		const textStyle = guide.textWidth ? { width: guide.textWidth } : {};
		return (
			<div className="guide guide__astro">
				<div className="guide-text">
					<h3>{guide.title}</h3>
					{showButton ? 
						<Button
							className="slds-float_right"
							onClick={this.props.onClick}
							variant="brand"
						>
							{guide.button}
						</Button> :
						null
					}
					<p className="slds-p-top_xx-small" style={textStyle}>{guide.description}</p>
					<span className="guide__close" onClick={this.handleClose} />
				</div>
			</div>
		);
	}

	renderEinsteinGuide (guide: GuideText) {
		const showButton = Boolean(guide.button);
		const textStyle = guide.textWidth ? { width: guide.textWidth } : {};
		return (
			<div className="guide guide__einstein">
				<div className="guide_bg-wrapper">
					<div className="guide-text">
						<span className="guide__einstein-head" />
						<h3>{guide.title}</h3>
						{showButton ?
							<Button
								className="slds-float_right"
								onClick={this.props.onClick}
								variant="brand"
							>
								{guide.button}
							</Button> :
							null
						}
						<p style={textStyle}>{guide.description}</p>
						<span className="guide__close" onClick={this.handleMapperClose} />
					</div>
				</div>
			</div>
		);
	}

	render () {
		const guide = this.props.brand.guide;

		if (guide === null || guide === undefined) {
			return null;
		}

		switch (guide.style) {
			case 'astro':
				return this.renderAstroGuide(guide);
			case 'einstein':
				return this.renderEinsteinGuide(guide);
			default:
				return null;
		}
	}
}

export default withBrand(Guide);


// WEBPACK FOOTER //
// ./src/Guide/index.tsx